import React, { useState } from "react";
import Base from "../admin_components/Admin_Base";
import "./addmanualpayments.css";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const AddManualInvoices = () => {
  const [manualPayments, setManualPayments] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [passbookNumber, setPassbookNumber] = useState("");
  const [emiYear, setEmiYear] = useState("");
  const [emiMonth, setEmiMonth] = useState("");
  const [amount, setAmount] = useState("");

  const handleGenerateInvoice = () => {
    if (
      !customerName ||
      !propertyName ||
      !passbookNumber ||
      !emiYear ||
      !emiMonth ||
      !amount
    ) {
      alert("Please fill all mandatory fields.");
      return;
    }

    const newPayment = {
      id: manualPayments.length + 1,
      sno: manualPayments.length + 1,
      customerName,
      passbookNo: passbookNumber,
      PropertyName: propertyName,
      emiyear: emiYear,
      emimonth: emiMonth,
      amount,
      status: "Paid",
    };

    setManualPayments([...manualPayments, newPayment]);

    setCustomerName("");
    setPropertyName("");
    setPassbookNumber("");
    setEmiYear("");
    setEmiMonth("");
    setAmount("");

    alert(`Invoice Generated for ${customerName}`);
  };

  return (
    <Base>
      <div
        className="pt-3 mt-5"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="hover"
            key="2"
            color="inherit"
            href="/admin/Add_Manual_Invoices"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Add Manual Invoice
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">Add Manual Payment Receipt</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "94%" }} />
      </div>

      <div className="add-manual-invoices-container">
        <div className="form-container">
          {/* <h2>Add Manual Invoice</h2> */}
          <div className="form-group-container">
            <div className="form-group">
              <label>Customer Name *</label>
              <input
                type="text"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Property Name *</label>
              <input
                type="text"
                value={propertyName}
                onChange={(e) => setPropertyName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Passbook Number *</label>
              <input
                type="text"
                value={passbookNumber}
                onChange={(e) => setPassbookNumber(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>EMI Year *</label>
              <select
                value={emiYear}
                onChange={(e) => setEmiYear(e.target.value)}
                required
              >
                <option value="">Select Year</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2025">2026</option>
                <option value="2025">2027</option>
                <option value="2025">2028</option>
                <option value="2025">2029</option>
                <option value="2025">2030</option>
                <option value="2025">2031</option>
                <option value="2025">2032</option>
                <option value="2025">2033</option>
                <option value="2025">2034</option>
              </select>
            </div>
            <div className="form-group">
              <label>EMI Month *</label>
              <select
                value={emiMonth}
                onChange={(e) => setEmiMonth(e.target.value)}
                required
              >
                <option value="">Select Month</option>
                <option value="January">January</option>
                <option value="February">February</option>
                <option value="March">March</option>
                <option value="April">April</option>
                <option value="May">May</option>
                <option value="June">June</option>
                <option value="July">July</option>
                <option value="August">August</option>
                <option value="September">September</option>
                <option value="October">October</option>
                <option value="November">November</option>
                <option value="December">December</option>
              </select>
            </div>
            <div className="form-group">
              <label>Amount *</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="amount-input"
                required
              />
            </div>
          </div>

          <div className="button-container">
            <button className="manual" onClick={handleGenerateInvoice}>
              Generate Payment Reciept
            </button>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default AddManualInvoices;
